/**
 * HIPAA Session Expiry Page
 * 
 * Displayed when:
 * - Session times out due to 15-minute inactivity
 * - Token refresh fails
 * - User is forcefully logged out
 * 
 * Explains HIPAA compliance requirement
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SessionExpired.css';

const SessionExpired = () => {
  const navigate = useNavigate();

  const handleLoginAgain = () => {
    navigate('/login');
  };

  return (
    <div className="session-expired-container">
      <div className="session-expired-card">
        <div className="session-expired-icon">🔒</div>
        
        <h1 className="session-expired-title">
          Session Expired
        </h1>
        
        <p className="session-expired-message">
          Your session has expired due to inactivity.
        </p>
        
        <div className="session-expired-info">
          <p>
            <strong>Why did this happen?</strong>
          </p>
          <p>
            For your security and to comply with HIPAA regulations, we automatically 
            log you out after <strong>15 minutes of inactivity</strong>.
          </p>
          <p>
            This protects sensitive health information from unauthorized access when 
            you step away from your computer.
          </p>
        </div>
        
        <button 
          onClick={handleLoginAgain}
          className="btn btn-primary session-expired-btn"
          autoFocus
        >
          Login Again
        </button>
        
        <p className="session-expired-footer">
          Your work has been saved. Please log in to continue.
        </p>
      </div>
    </div>
  );
};

export default SessionExpired;

